var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb24HrWindowErrorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4399",
    "data-name": "Group 4399",
    transform: "translate(-880 -552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chatbubble-ellipses_1_",
    "data-name": "chatbubble-ellipses (1)",
    d: "M46.7,34a9.137,9.137,0,0,0-5.713-2,9.031,9.031,0,0,0-6.443,2.655,8.692,8.692,0,0,0-1.118,10.93l.008.011.035.049.029.042.009.016a.352.352,0,0,1,.049.277l-.74,2.678a1.17,1.17,0,0,0-.048.307A1.032,1.032,0,0,0,33.8,50a1.183,1.183,0,0,0,.42-.092l2.712-.979.034-.013a.593.593,0,0,1,.233-.046.608.608,0,0,1,.216.04c.065.025.656.252,1.28.426a10.583,10.583,0,0,0,2.442.362A8.836,8.836,0,0,0,50,40.819a8.578,8.578,0,0,0-.192-1.808A8.813,8.813,0,0,0,46.7,34ZM34.228,45.982Zm2.914-3.7A1.286,1.286,0,1,1,38.428,41,1.286,1.286,0,0,1,37.142,42.286Zm3.857,0A1.286,1.286,0,1,1,42.285,41,1.286,1.286,0,0,1,41,42.286Zm3.857,0A1.286,1.286,0,1,1,46.142,41,1.286,1.286,0,0,1,44.856,42.286Z",
    transform: "translate(848.001 520)",
    fill: "#e00f0f"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    x2: 10,
    y2: 10,
    transform: "translate(884 556)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb24HrWindowErrorIcon);
export default __webpack_public_path__ + "static/media/fb-24hr-window-error-icon.99561dcbe5bb1f83c061d24ab381e4a0.svg";
export { ForwardRef as ReactComponent };